module.exports = __webpack_public_path__ + "img/17.f0224e62.png";